import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import moment from 'moment';

export default function Investment({ data, compact, isNpo = false }) {
  if (!data) {
    return null;
  }
  // 10/26/2021 13:54
  //moment(report?.updated_at, "MM-DD-YYYY, HH:mm").format("YYYY-MM-DD[T]HH:mm:ss")

  const { report, invested, granteeFullName, donorFullName } = data; // data = report
  const lastUpdated = compact
    ? (
      <RowWithTopLine>
        <InvestmentTitle>Last Updated:</InvestmentTitle>
        <InvestmentValue>
          <b>{moment(report?.updated_at, 'MM-DD-YYYY, HH:mm').format('MMM Do YYYY, hh:mm a')}</b>
          {' '}by {report?.program_manager||donorFullName||granteeFullName}
        </InvestmentValue>
      </RowWithTopLine>
    )
    : (
      <RowWithLine>
        <InvestmentTitle>Last Updated:</InvestmentTitle>
        <InvestmentValue bold>{moment(report?.updated_at, 'MM-DD-YYYY, HH:mm').format('MMM Do YYYY, hh:mm a')}</InvestmentValue>
        <InvestmentValue>by {report?.program_manager||donorFullName||granteeFullName}</InvestmentValue>
      </RowWithLine>
    );

  return (
    <Root>
      <Col>
        {!isNpo && (<Row noPadding={compact}>
          <Padding noPadding={!compact}>
            <InvestmentTitle>Investment:</InvestmentTitle>
            <InvestmentValue bold>${numeral(invested).format('0,0')}</InvestmentValue>
          </Padding>
        </Row>)}
        <RowWithLine>
          <Padding noPadding={!compact}>
            <InvestmentTitle>Report Stage:</InvestmentTitle>
            <StageDiagram stage={stages[report?.stage || '-']} />
          </Padding>
        </RowWithLine>
        {!compact && lastUpdated}
      </Col>
      {compact && (
        <Col>
          <Row noPadding={compact}>
            {lastUpdated}
          </Row>
        </Col>
      )}
    </Root>
  );
}

const Padding = styled.div`
  ${({ noPadding }) => !noPadding && 'padding: 10px;'}
`;

const Col = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  &.top {
    div {
      color: #0073a3;
      span.title {
        margin-left: 30px;
        font-family: Roboto;
        font-size: 32px;
        color: #595959;
      }
      sup {
        font-size: 16px;
      }
      button {
        margin-top: 10px;
        float: right;
        text-transform: none !important;
      }
    }
  }
`;

const Row = styled.div`
  flex: 1;
  ${({ noPadding }) => !noPadding && 'padding: 10px;'}
`;

const RowWithLine = styled(Row)`
  border-left: 1px solid #CBD6E2;
`;

const RowWithTopLine = styled(Row)`
  border-top: 1px solid #CBD6E2;
`;

const Root = styled.div`
  background-color: #fff;
  border: 1px solid #DADCE0;
`;

const InvestmentTitle = styled.div`
  color: #595959;
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
`;

const InvestmentValue = styled.div`
  color: #99ACC2;
  font-size: 16px;
  line-height: 28px;
  ${({ bold }) => bold && 'font-weight: bold;'}
`;


const stages = {
  None: 0,
  Initial: 1,
  Act: 2,
  Capacity: 2,
  Catalyze: 2,
  Interim: 2,
  Learn: 2,
  Succeed: 2,
  Reach: 2,
  Final: 3,
};

const StageDiagram = ({ stage }) => (stage
  ? <img src={`/images/stage${stage}.png`} />
  : null
);
